/**
 * Messages liés à la gestion du marronnier
 */

module.exports = {

    mode: {
        button: {
            list: {
                label: 'List',
                altLabel: 'Display as a list.'
            },
            calendar: {
                label: 'Calendar',
                altLabel: 'Display as a calendar'
            }
        }
    },

    activitySectorsFiltered: {
        universal: 'Universal',
        sectorial: 'Sectorial'
    },

    create: {
        button: {
            label: 'Add'
        },
        modal: {
            title: 'Add an evergreen'
        }
    },

    edit: {
        button: {
            label: 'Edit',
            altLabel: 'Edit an event { event } for an evergreen.'
        },
        modal: {
            title: 'Event edition { event }'
        }
    },

    import: {
        button: {
            label: 'Importing events for an evergreen'
        },
        modal: {
            title: 'Events importation for an evergreen'
        }
    },

    consult: {
        button: {
            altLabel: 'View event details { event }.'
        },
        details: {
            sections: {
                date: 'Date',
                conversion: 'Status',
                sectorial: 'Status',
                description: 'Description',
                hook: 'Hook'
            },
            publicationConverted: {
                yes: 'Converted to publication',
                no: 'Not converted to publication'
            }
        },
        slideshow: {
            title: 'Events of the fay of { date }',
            navigation: {
                description: 'Navigate through the day\'s events'
            }
        }
    },

    convertInTask: {
        button: {
            label: 'Convert to publication',
            altLabel: 'Convert an event { event } to publication.'
        },
        modal: {
            title: 'Convert to publication',
            networks: {
                compatible: {
                    empty: 'No compatible social network found.'
                }
            },
            creditsToUse: 'will be used | will be used | will be used'
        },
        form: {
            convertInReturn: {
                error: 'An error occurred during the conversion of the event { event }.',
                button: {
                    credits: {
                        label: '<a href="{ url }" title="">Access credits</a>.'
                    }
                },
                fields: {
                    networks: 'Choice of network',
                    withLogo: 'Display logo on visual',
                    logo: {
                        unknown: 'Upload my logo',
                        current: 'Your logo is already uploaded, you can modify it below'
                    },
                    submit: 'Convert to publication'
                }
            }
        }
    },

    list: {
        table: {
            fields: {
                importId: 'Import ID',
                importParentId: 'Parent import ID',
                date: 'Date',
                title: 'Title',
                preview: 'Preview',
                description: 'Description',
                activitySectorsFiltered: 'Filter',
                status: 'Status',
                canvaUrl: 'Canva Project'
            },
            canva: {
                button: {
                    label: 'Canva Project'
                }
            }
        }
    },

    calendar: {
        event: {
            publicationConverted: {
                yes: 'Converted',
                no: 'Not converted'
            }
        }
    },

    // Suggestion de publication sur la page d'accueil du client
    publicationSuggestion: {
        title: 'Post suggestion',
        section: {
            date: 'Date',
            hook: 'Hook',
            status: 'Status',
            description: 'Description',
        }
    }

};
